import React, { useState, useEffect } from "react";
import Textarea from "sushiweb/InputTypes/Textarea";
import Input from "sushiweb/InputTypes/Input";
import Button from "sushiweb/Button";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import Permission from "../../Common/Permission";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";

import * as CountryActions from "../../../store/actions/Country";
import * as UserActions from "../../../store/actions/User";
import {
  getInitialState,
  getReadableDateTime,
  isValidated,
  filterObj,
} from "../../../utils";
import { BottomSectionModal } from "../../../constants/assets/containers";
import NoFooterModal from "../../Common/NoFooterModal";
import variables from "../../../constants/assets/variables";

const mandatoryFields = ["country_name", "iso_code"];

const CountryFormModal = (props) => {
  const { activeId, modalState, handleModalClose, activeCountry, setStatus } =
    props;
  const allActions = MenuActionsMappings[MenuNames.COUNTRY];
  const [initialState, setInitialState] = useState({
    country_name: "",
    iso_code: "",
    config: "",
    updated_at: "",
    created_at: "",
  });

  // check if the required fields are filled
  // and config is in correct json format.
  const handleSubmit = (evt) => {
    evt.preventDefault();
    const validatedState = isValidated(initialState, mandatoryFields);
    let isJsonCorrect = true;
    try {
      if (initialState.config.length > 0) {
        JSON.parse(initialState.config);
      }
    } catch (err) {
      isJsonCorrect = false;
    }

    // add errors if there is any.
    if (validatedState !== "validated") {
      setStatus({ type: "error", message: validatedState });
    } else if (isJsonCorrect === false) {
      setStatus({
        type: "error",
        message: "Config is not in correct json format.",
      });
    } else {
      // send request if there are no errors.
      const body = filterObj(initialState, [
        "country_name",
        "iso_code",
        "config",
      ]);

      // convert config object to JSON format.
      if (body.config.length > 0) {
        body.config = JSON.parse(body.config);
      } else {
        body.config = {};
      }

      const pageRequest = {
        page: props.currentPage,
      };

      if (modalState === "Edit") {
        props.updateCountry(activeId, body).then((res) => {
          props.getCountryList({}, pageRequest);
          handleModalClose();
        });
      } else if (modalState === "Add") {
        props.createCountry(body).then((res) => {
          props.getCountryList({}, pageRequest);
          handleModalClose();
        });
      }
    }
  };

  const handleChange = (key, val) => {
    const nextState = { ...initialState };
    nextState[key] = val;
    setInitialState(nextState);
  };

  useEffect(() => {
    if (activeId) {
      props.getCountry(activeId);
    }

    // if modal is in Add state and also activeCountry is set in redux store,
    // then reset the value of activeCountry, otherwise it will get rendered in
    // modal.
    if (modalState === "Add" && Object.keys(activeCountry).length > 0) {
      props.resetState({ state: "activeCountry" });
    }
  }, [activeId, modalState]);

  // set initial values in modal.
  useEffect(() => {
    if (activeCountry) {
      const values = { ...initialState };
      Object.keys(values).forEach((key) => {
        values[key] = activeCountry[key]
          ? typeof activeCountry[key] === "object"
            ? JSON.stringify(activeCountry[key])
            : activeCountry[key]
          : getInitialState(initialState, key);
      });
      setInitialState(values);
    }
  }, [activeCountry]);

  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Country`}
      handleClose={handleModalClose}
      id="CountryFormModal"
      modalButtons={
        <BottomSectionModal className="flex items-center justify-between">
          <Permission optionalPerms={[allActions.CREATE, allActions.UPDATE]}>
            <Button
              data-testid="submitButton"
              className="sushi-btn"
              onClick={handleSubmit}
            >
              Submit
            </Button>
          </Permission>
        </BottomSectionModal>
      }
    >
      <Input
        value={initialState.country_name}
        data-testid="countryName"
        id="sushi-input"
        onChange={(e) => handleChange("country_name", e)}
        label="Name"
      />
      <Input
        value={initialState.iso_code}
        data-testid="countryIsoCode"
        id="sushi-input"
        onChange={(e) => handleChange("iso_code", e)}
        label="ISO Code"
      />
      <Textarea
        id="sushi-textarea"
        data-testid="countryConfig"
        borderColor={variables.primaryColor}
        innerWidth="100%"
        className="mb-20"
        resize="none"
        label="Config"
        onChange={(e) => handleChange("config", e)}
        value={initialState.config}
      />
      {modalState === "Edit" && (
        <>
          <Input
            disabled
            value={getReadableDateTime(initialState.created_at)}
            data-testid="countryCreatedAt"
            id="sushi-input"
            label="Created At"
          />
          <Input
            disabled
            value={getReadableDateTime(initialState.updated_at)}
            data-testid="countryUpdatedAt"
            id="sushi-input"
            label="Updated At"
          />
        </>
      )}
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { Country } = state;
  return {
    activeCountry: Country.activeCountry,
    currentPage: Country.currentPage,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCountryList: bindActionCreators(CountryActions.getCountryList, dispatch),
    createCountry: bindActionCreators(CountryActions.createCountry, dispatch),
    getCountry: bindActionCreators(CountryActions.getCountry, dispatch),
    resetState: bindActionCreators(CountryActions.resetState, dispatch),
    updateCountry: bindActionCreators(CountryActions.updateCountry, dispatch),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CountryFormModal);
